import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * EncounterCategories — admin CRUD for the picker behind a sighting's
 * "reaction" field. Lists include soft-deleted rows so admins can
 * revive them; non-admins receive 403 on save/delete.
 */
export class EncounterCategories {
    static async getList() {
        var _a;
        const result = await NetFetch.getData('/json/encountercategories/list');
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = result.list) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
    static async save(entry) {
        const result = await NetFetch.postData('/json/encountercategories/save', entry);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
                default:
                    if (result.msg) {
                        throw new Error(result.msg);
                    }
            }
        }
        return false;
    }
    static async delete(req) {
        const result = await NetFetch.postData('/json/encountercategories/delete', req);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return false;
    }
}
